/**
 * @packageDocumentation
 * @module SvgIcon
 * @category Core
 */
import { EnvironmentProviders, inject, provideAppInitializer, Provider } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Регистрация SVG-иконок в `MatIcon`.
 *
 * @param icons
 * @returns
 */
export function provideSvgIcons(icons: string[]): (Provider | EnvironmentProviders)[] {
  return [
    provideAppInitializer(() => {
      const iconRegistry = inject(MatIconRegistry);
      const sanitizer = inject(DomSanitizer);

      icons.forEach((icon) =>
        iconRegistry.addSvgIcon(icon, sanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/svg/${icon}.svg`)),
      );
    }),
  ];
}
